import React, { useEffect, useState } from 'react';
import { useInView, usePrefersReducedMotion } from '../../hooks/useReveal';

/** Counts from 0 to `to` when scrolled into view. */
function Counter({ to, suffix = '', prefix = '', duration = 1600 }) {
  const [ref, inView] = useInView();
  const reduced = usePrefersReducedMotion();
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return undefined;
    if (reduced) { setVal(to); return undefined; }
    let raf;
    const t0 = performance.now();
    const tick = (now) => {
      const p = Math.min((now - t0) / duration, 1);
      setVal(Math.round(to * (1 - Math.pow(1 - p, 4))));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, to, duration, reduced]);

  return <span ref={ref}>{prefix}{val}{suffix}</span>;
}

export default Counter;
